var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Title',{attrs:{"title":"发热人员情况统计"}},[(_vm.ifShowEcharts)?_c('Echarts',{staticStyle:{"width":"100%","height":"100%"},attrs:{"options":_vm.polar,"autoresize":""}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }